import {AnyAction} from 'redux';
import {ISlidesAnalytics} from '../../incase-domain/proptypes/slidesAnalytics';
import {UPDATE_SLIDES_ANALYTICS, UPDATE_SLIDES_ANALYTICS_UPDATE_TIME} from '../actions/types/analytics.actions.types';

export interface SlidesAnalyticsReducerState {
    slidesAnalytics: ISlidesAnalytics;
    lastUpdate: number;
}

export const preloadedState: SlidesAnalyticsReducerState = {
    slidesAnalytics: {_id: '', slidesData: []},
    lastUpdate: Date.now(),
};

export const slidesAnalyticsReducer = (
    state: SlidesAnalyticsReducerState = preloadedState,
    action: AnyAction
): SlidesAnalyticsReducerState => {
    switch (action.type) {
        case UPDATE_SLIDES_ANALYTICS:
            return {...state, slidesAnalytics: action.slidesAnalytics, lastUpdate: Date.now()};
        case UPDATE_SLIDES_ANALYTICS_UPDATE_TIME:
            return {...state, lastUpdate: action.time};
        default:
            return state;
    }
};
